export default __webpack_public_path__ + "static/media/img-0598-liechtenstein-full-face.9ad1fc7f.png";